<template>
  <v-dialog
    v-model="opened"
    content-class="new-status"
    max-width="370"
    persistent
  >
    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <h3>{{ $t('workersList.selectNewStatus') }}</h3>

    <v-form ref="new-status" @submit.prevent="onSubmit">
      <v-select
        v-model="status"
        class="mt-5"
        item-value="id"
        item-text="name"
        dense
        outlined
        :label="$t('common.fields.status')"
        :items="filteredStatuses"
        :rules="[isRequired]"
      />

      <v-btn type="submit" color="warning" elevation="0" block>
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    status: '',
  }),
  watch: {
    opened(val) {
      if (!val) this.$refs['new-status'].reset();
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    filteredStatuses() {
      const { carStatuses } = this.$store.state['workers-board'];

      return carStatuses.filter(({ id }) => {
        const driverStatusIds = [0, 1, 5, 8, 9, 11];
        return !driverStatusIds.includes(Number(id));
      });
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    onSubmit() {
      const isValid = this.$refs['new-status'].validate();

      if (isValid) {
        this.$emit('save', this.status);
        this.opened = false;
      }
    },
  },
};
</script>

<style lang="scss">
.new-status {
  padding: 10px;
  background-color: #fff;
}
</style>
